import type { HTMLAttributes, ReactNode } from 'react';

export type PillStatus =
  | 'todo'
  | 'progress'
  | 'review'
  | 'blocked'
  | 'done'
  | 'cancel'
  | 'draft'
  | 'published'
  | 'active'
  | 'pending'
  | 'expired'
  | 'suspended';

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  status: PillStatus;
  children: ReactNode;
}

/**
 * Status pill — 18px height, outline-only (border + text via currentColor),
 * mono lowercase, 5×5 dot prefix. Matches dashboard.html `.pill`.
 */
export function Pill({ status, children, className, ...rest }: PillProps) {
  const cls = ['pn-pill', `pn-pill-${status}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      <span className="pn-pill-dot" aria-hidden="true" />
      {children}
    </span>
  );
}
